<template>
  <PartySection />
</template>

<script>
import PartySection from '../../components/party/PartySection.vue'

export default {
  name: 'PartyPage',
  components: { PartySection }
}
</script>
